// src/pages/ChatDocuments/idOf.ts
export const idOf = (v: any): string => {
    if (!v) return "";
    if (typeof v === "string" || typeof v === "number") return String(v);
    const cand = v._id ?? v.id ?? v.userId ?? v.uid ?? v.$oid;
    return cand != null
      ? String(cand)
      : (typeof v.toString === "function" ? String(v.toString()) : "");
  };
  